import arSA from "./translations/ar-SA.json";
import bgBG from "./translations/bg-BG.json";
import caES from "./translations/ca-ES.json";
import csCZ from "./translations/cs-CZ.json";
import cyGB from "./translations/cy-GB.json";
import daDK from "./translations/da-DK.json";
import deDE from "./translations/de-DE.json";
import elGR from "./translations/el-GR.json";
import enGB from "./translations/en-GB.json";
import enUS from "./translations/en-US.json";
import esES from "./translations/es-ES.json";
import esMX from "./translations/es-MX.json";
import fiFI from "./translations/fi-FI.json";
import frCA from "./translations/fr-CA.json";
import frFR from "./translations/fr-FR.json";
import gaIE from "./translations/ga-IE.json";
import heIL from "./translations/he-IL.json";
import hiIN from "./translations/hi-IN.json";
import huHU from "./translations/hu-HU.json";
import idID from "./translations/id-ID.json";
import isIS from "./translations/is-IS.json";
import itIT from "./translations/it-IT.json";
import jaJP from "./translations/ja-JP.json";
import koKR from "./translations/ko-KR.json";
import nbNO from "./translations/nb-NO.json";
import nlNL from "./translations/nl-NL.json";
import plPL from "./translations/pl-PL.json";
import ptBR from "./translations/pt-BR.json";
import ptPT from "./translations/pt-PT.json";
import roRO from "./translations/ro-RO.json";
import ruRU from "./translations/ru-RU.json";
import svSE from "./translations/sv-SE.json";
import thTH from "./translations/th-TH.json";
import tlPH from "./translations/tl-PH.json";
import trTR from "./translations/tr-TR.json";
import viVN from "./translations/vi-VN.json";
import zhCN from "./translations/zh-CN.json";
import zhTW from "./translations/zh-TW.json";
import { TranslationValue } from "../types";

export const translatedLocales: Record<string, TranslationValue> = {
  "ar-SA": arSA,
  "bg-BG": bgBG,
  "ca-ES": caES,
  "cs-CZ": csCZ,
  "cy-GB": cyGB,
  "da-DK": daDK,
  "de-DE": deDE,
  "el-GR": elGR,
  "en-GB": enGB,
  "en-US": enUS,
  "es-ES": esES,
  "es-MX": esMX,
  "fi-FI": fiFI,
  "fr-CA": frCA,
  "fr-FR": frFR,
  "ga-IE": gaIE,
  "he-IL": heIL,
  "hi-IN": hiIN,
  "hu-HU": huHU,
  "id-ID": idID,
  "is-IS": isIS,
  "it-IT": itIT,
  "ja-JP": jaJP,
  "ko-KR": koKR,
  "nb-NO": nbNO,
  "nl-NL": nlNL,
  "pl-PL": plPL,
  "pt-BR": ptBR,
  "pt-PT": ptPT,
  "ro-RO": roRO,
  "ru-RU": ruRU,
  "sv-SE": svSE,
  "th-TH": thTH,
  "tl-PH": tlPH,
  "tr-TR": trTR,
  "vi-VN": viVN,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
};
